






























































import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings, InputWings, TextareaWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {BlacklistItem} from "@/store/blacklists/types";
import { ActionLog } from "@/store/auth/types";
import { getTranslatedParams } from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {FormRowWings, SelectWings, InputWings, TextareaWings}})
export default class BlackList extends Vue{
  @Ref('validator') validator:any;
  @Action("getBlackListItem") actionGetItem: any;
  @Action("saveBlackList") actionSave: any;
  @Action("deleteBlackList") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item = new BlacklistItem()
  private itemSaved = new BlacklistItem()
  private checkDuplicates = true
  logObject: ActionLog = {}

  policiesMap = {
    1: this.$t('contacts.checkDuplicatesPolicies.msisdn').toString(),
    2: this.$t('contacts.checkDuplicatesPolicies.email').toString(),
    3: this.$t('contacts.checkDuplicatesPolicies.msisdn_email').toString(),
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: 'success',
          objectType: "Blacklist",
          objectName: this.item.name,
        }
        const data = await this.actionGetItem(this.$route.params.id)
        if (data.checkDuplicatesPolicy === 0) this.checkDuplicates = false;
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
        this.logObject.objectName = this.item.name
        await this.actionLog(this.logObject)
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    }
  }

  back() {
    this.$router.push('/black_list/group');
  }

  onSaveItem():Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          actionStatus: 'success',
          objectType: "Blacklist",
          objectName: this.item.name,
          addititionalInfo: getTranslatedParams({
            comment: this.item.comment,
            //@ts-ignore
            checkDuplicatesPolicy: this.policiesMap[this.item.checkDuplicatesPolicy]})
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject)
        this.itemSaved = cloneDeep(this.item);
        resolve()
        this.back();
      } catch (error) {
        reject()
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: "Blacklist",
        objectName: this.item.name,
        addititionalInfo: getTranslatedParams({id: this.item.blackListId})
      }
      await this.actionDelete({blacklistId: this.item.blackListId})
      await this.actionLog(this.logObject)
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('checkDuplicates', {immediate: true})
  onChangeCheckDuplicates(val?: boolean) {
    if (!val) {
      this.item.checkDuplicatesPolicy = 0
    } else {
      this.item.checkDuplicatesPolicy = 3
    }
  }

}
